export default __webpack_public_path__ + "assets/unibas.c25fd1e.svg";